import { IRentLicensesStore } from './index'

export default {
  licenses: [],
} as IRentLicensesStore
